module.exports = __webpack_public_path__ + "static/media/logo11.900031ff.png";